<template>
  <div>
    <div v-if="$store.state.modules.account.user" class="navbar-nav small ms-auto mb-2 mb-lg-0 dropdown">
      <li class="nav-item">
        <button class="nav-link text-light btn" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false">
          <i class="fa-solid fa-sm fa-user"></i>
          {{ $store.state.modules.account.user.username }}
        </button>
      </li>
      <div id="navbarNav" class="dropdown-menu position-absolute top-0 end-0 bg-light m-3">
        <router-link :to="{ name: 'CPanel' }" custom v-slot="{ navigate }">
          <span
            role="link"
            @click="navigate"
            class="btn dropdown-item"
            @keypress.enter="navigate"
          >
            <i class="fa-solid fa-sm text-primary fa-user"></i>
            Konto
          </span>
        </router-link>

        <router-link :to="{ name: 'Setting' }" custom v-slot="{ navigate }">
          <span
            role="link"
            @click="navigate"
            class="btn dropdown-item"
            @keypress.enter="navigate"
          >
            <i class="fa-solid fa-sm text-primary fa-gear"></i>
            Einstellungen
          </span>
        </router-link>
        <router-link
          :to="{ name: 'UpdatePassword' }"
          custom
          v-slot="{ navigate }"
        >
          <span
            role="link"
            @click="navigate"
            class="btn dropdown-item"
            @keypress.enter="navigate"
          >
            <i class="fa-solid fa-sm text-primary fa-key"></i>
            Passwort ändern
          </span>
        </router-link>

        <li><hr class="dropdown-divider" /></li>

        <button class="btn dropdown-item" @click="signout">
          <i class="fa-solid fa-sm text-primary fa-right-from-bracket"></i>
          Abmelden
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",

  components: { },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  watch: {},

  methods: {
    signout() {
      this.$store.state.utils.processing = true;
      this.$store.state.modules.api
        .signout(JSON.parse(localStorage.account).token)
        .then(() => {
          this.$store.state.modules.account.user = undefined;
          this.$store.state.modules.account.token = undefined;
          location.reload();
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
